export default "__VITE_ASSET__bfc4dace__"